import { useLiveQuery } from 'dexie-react-hooks'
import { db } from '../lib/db/indexeddb'

type LifeSpace = 'personal' | 'work' | 'home'

/**
 * Returns true if the Kurz-notiert queue for the given lifeSpace contains
 * at least one actionable entry (orphan + matching lifespace + not paused /
 * scheduled / completed / deleted). Used in the sidebar to swap between
 * the "filled notepad" icon and the "emptied / checked notepad" icon.
 *
 * Post-PR 2 of the lifeSpace migration this reads from the new orphan-based
 * query rather than the retired `quick-notes` system project. Returns false
 * while the underlying live query is loading — the empty-state icon is the
 * safer default visually.
 */
export function useQuickNotesHasEntries(lifeSpace: LifeSpace): boolean {
  const count = useLiveQuery(
    () => db.getQuickNotesByLifeSpace(lifeSpace).then(tasks => tasks.length),
    [lifeSpace],
    0,
  )

  return (count ?? 0) > 0
}
